<div #apptoast class="toast position-fixed bottom-0 start-50 translate-middle-x text-bg-danger z-2" role="alert" aria-live="assertive" aria-atomic="true"
    data-bs-config='{"delay":2500, "autohide": true, "animation": true}'>
    <div class="toast-body text-center">
    <p>{{toastMessage}}</p>
    </div>
</div>